import ActionTypes from "../Actions/ActionTypes";

let initialState = {
  chats: [],
  chatPagination: null,

  // chatHeads: [],
  // chatHeadsPagination: null,
};

const ChatReducer = (state = initialState, action) => {
  
  switch (action.type) {
    // case ActionTypes.GET_CHAT_HEADS:
    //     let chat_heads_list_copy = [];
    //     chat_heads_list_copy = [...state.chatHeads, ...action.payload?.data];
    //     state = { ...state, chatHeadsPagination: action.payload, chatHeads: chat_heads_list_copy, };
    //     break;

    // case ActionTypes.CLEAR_CHAT_HEADS:
    //     state = { ...state, chatHeads: [], chatHeadsPagination: null }
    //     break;

    case ActionTypes.GET_CHATS:
      if (
        state?.chatPagination?.meta?.current_page !=
        action.payload?.meta?.current_page
      ) {
        let chat_messages_list_copy = [];
        chat_messages_list_copy = [...state.chats, ...action.payload.data];
        state = {
          ...state,
          chatPagination: action.payload,
          chats: chat_messages_list_copy,
        };
      }
      break;

    case ActionTypes.UPDATE_CHATS:
      let existing_chats = [...state.chats];
      let messageExist =
        existing_chats?.findIndex((item) => item?.id == action.payload?.id) !=
        -1
          ? true
          : false;
      if (!messageExist) {
        existing_chats.unshift(action.payload);
      }
      state = { ...state, chats: existing_chats };
      break;

    // case ActionTypes.UPDATE_CHATLIST:
    //     state = { ...state, chatHeads: action.payload.data };
    //     break;

    case ActionTypes.CLEAR_CHATS:
      state = { ...state, chats: [], chatPagination: null };
      break;

    default:
      break;
  }
  return state;
};

export default ChatReducer;
